var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import PersonHighSchoolDomainService from "../Domain/PersonHighSchool/PersonHighSchool.service";
import PersonPhoneDomainService from "../Domain/PersonPhone/PersonPhone.service";
import GenderService from "./Gender.service";
const BASE_URL = "/aviso/prospect";
export default class ProspectService {
    static saveProspect(prospect) {
        return FetchService.postSingleResponse(BASE_URL + "/saveProspect", prospect);
    }
    static getProspectInfo(personId) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getSingleResponse(BASE_URL + "/getProspectInfo", {
                personId,
            });
            // GenderDTO only exists on the clientside for now.  So, we make another service call, but really
            // this all stays clientside
            const genderFull = resp.genderCharacter
                ? yield GenderService.findById(resp.genderCharacter)
                : undefined;
            return Object.assign(Object.assign({}, resp), { personHighSchools: resp.personHighSchools.map(PersonHighSchoolDomainService.fromJSON), personPhones: resp.personPhones.map(PersonPhoneDomainService.fromJSON), 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS2571 - Object is of type 'unknown'.
                birthDate: resp.birthDate && new Date(resp.birthDate), 
                // Doing this because we don't have GenderDto on backend and these values only exist on frontend
                genderFull });
        });
    }
}
